(() => {
  const PROJECT_TYPES = Object.freeze({
    bulk: 'Business / bulk order',
    'custom-gift': 'Personalized gift',
    custom: 'Custom laser job'
  });

  const cleanText = (value, maxLength) => value
    .replace(/[\u0000-\u001F\u007F]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, maxLength);

  const setField = (form, key, value, maxLength) => {
    const field = form.querySelector(`[data-contact-field="${key}"]`);
    if (!field || !value) return;
    field.value = cleanText(value, maxLength);
  };

  const selectProjectType = async (form, selectedValue) => {
    if (!selectedValue) return false;

    await customElements.whenDefined('custom-select');
    const nativeSelect = form.querySelector('select[name="contact[Project type]"]');
    if (!nativeSelect || !Array.from(nativeSelect.options).some((option) => option.value === selectedValue)) {
      return false;
    }

    const customSelect = nativeSelect.closest('.option-selector')?.querySelector('custom-select');
    const customOption = customSelect
      ? Array.from(customSelect.querySelectorAll('.custom-select__option')).find((option) => option.dataset.value === selectedValue)
      : null;

    if (customSelect && customOption && typeof customSelect.selectOption === 'function') {
      customSelect.selectOption(customOption);
    } else {
      nativeSelect.value = selectedValue;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return true;
  };

  const initForm = async (form) => {
    const params = new URLSearchParams(window.location.search);
    const projectType = PROJECT_TYPES[params.get('project')];
    const status = form.querySelector('[data-contact-intent-status]');

    setField(form, 'product-item', params.get('product'), 160);

    const quantity = params.get('quantity');
    if (quantity && /^\d{1,6}$/.test(quantity)) {
      setField(form, 'quantity', quantity, 6);
    }

    const source = params.get('source');
    if (source && /^[a-z0-9_-]{1,40}$/i.test(source)) {
      setField(form, 'source', source, 40);
    }

    if (await selectProjectType(form, projectType)) {
      status.textContent = `Project type set to ${projectType}.`;
    }

    let invalidField = null;
    form.addEventListener('invalid', (event) => {
      if (invalidField) return;
      invalidField = event.target;
      const label = form.querySelector(`label[for="${CSS.escape(invalidField.id)}"]`);
      status.textContent = `${label?.textContent.trim() || 'This field'} is required.`;
      window.requestAnimationFrame(() => { invalidField = null; });
    }, true);
  };

  document.querySelectorAll('.crc-contact-intent-form').forEach((form) => initForm(form));
})();
